import React, { useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { IEvent, User } from './types';

export default function Navigation({ theme, setEvent, user, setUser }: { 
  theme: string, 
  setEvent: React.Dispatch<React.SetStateAction<IEvent|null>>, 
  user: User|null,
  setUser: React.Dispatch<React.SetStateAction<User>>
}) {
  const [expanding, setExpanding] = useState<boolean>(false);
  const navigate = useNavigate();
	const expandToBudget = useCallback(() => {
    if (expanding) return;
    setEvent(null);
    navigate("/");
    setExpanding(true);
    setTimeout(() => {
      setExpanding(false);
    }, 500);

    if (user!.clearEvent) {
      setEvent(null);
      setUser({
        ...user!,
        clearEvent: false
      });
      navigate("/");
    }

    const body = document.body;
    const header = document.querySelector('header');

    if (body.classList.contains('view-left-right')) {
      body.classList.remove('view-left-right');
      body.classList.add('view-right-main');
    } else if (body.classList.contains('view-right-main')) {
      body.classList.add('view-left-right');
      body.classList.remove('view-right-main');
    } else if (body.classList.contains('view-left-main')) {
      body.classList.remove('view-left-main')
    } else {
      body.classList.remove('view-right-main');
      body.classList.add('view-left-main');
    }

    
  }, []);
  const expandToOutlook = useCallback(() => {
    if (expanding) return;
    setEvent(null);
    navigate("/");
    setExpanding(true);
    setTimeout(() => {
      setExpanding(false);
    }, 500);

    const body = document.body;
    const header = document.querySelector('header');

    if (body.classList.contains('view-left-right')) {
      body.classList.remove('view-left-right');
      body.classList.add('view-left-main');
    } else if (body.classList.contains('view-left-main')) {
      body.classList.add('view-left-right');
      body.classList.remove('view-left-main');
    } else if (body.classList.contains('view-right-main')) {
      body.classList.remove('view-right-main');
    } else {
      body.classList.remove('view-left-main');
      body.classList.add('view-right-main');
    }
  }, []);
	return window.innerWidth > 800 ? <>
    <button id="expand-to-budget" className={theme} onClick={expandToBudget}>☰</button>
    <button id="expand-to-outlook" className={theme} onClick={expandToOutlook}>☰</button>
  </> : null
}